import moment from 'moment';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setInitialData } from '@store/aiAlerts/base/actions';
import { track } from '@utils';
import { getAlertInsights } from '@api/autoInsights';
import { setFilter } from '@store/aiAlerts/summary/actions';
import { AUTO_INSIGHTS_ALERT_CLICK } from '@src/utils/sensor/track';
import { SettingTypes } from '../Settings';

const { baseUrl } = window.conviva;

const drawerEvent: any = new CustomEvent('auto-insights-drawer', {
  detail: { visible: false },
});

function useFetchSummary({ to, limit = 500 }) {
  return useQuery(
    [SettingTypes.alertInsights, to, limit],
    () =>
      getAlertInsights({
        params: {
          to,
          limit,
        },
      }),
    {
      // default cacheTime is 5 minutes
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}

const getFilterName = (values) => values.map(({ cause }) => cause).join(' | ');

function useSearchSummary({ interval, closeMore }) {
  const { start_ms, end_ms } = interval;
  const dispatch = useDispatch();
  const history = useHistory();

  return (alert) => {
    const { values, alertIds } = alert;
    dispatch(
      setFilter({
        name: getFilterName(values),
        alertIds,
      }),
    );
    dispatch(
      setInitialData({
        interval: {
          from: moment(start_ms).format(),
          to: moment(end_ms).format(),
          shortcut: 'custom',
        },
      }),
    );
    history.push(`${baseUrl}/dashboard/ai-alerts`);
    document.dispatchEvent(drawerEvent); // close main drawer
    closeMore(); // close more drawer
    track({ event: AUTO_INSIGHTS_ALERT_CLICK });
  };
}

export { drawerEvent, useFetchSummary, useSearchSummary };
